import { Stack } from '@mantine/core'
import { useGetLoraGateway } from 'api/loraGateways'
import { Query } from 'components/common'
import { useParams } from 'react-router-dom'
import { TGatewayListItem } from 'shared/types'
import { DeviceKeys } from './DeviceKeys'

export const LoraGatewayKeys = () => {
  const { deviceId } = useParams()
  const query = useGetLoraGateway(deviceId)

  return (
    <Query.Wrapper query={query}>
      <Query.Data>
        {(data: TGatewayListItem) => (
          <Stack>
            <DeviceKeys keys={data} />
          </Stack>
        )}
      </Query.Data>
    </Query.Wrapper>
  )
}
